import Modal from '@Components/Shared/Modals/Modal';
import BuyersPremiumForm from '@Components/Forms/BuyersPremiumForm';
import translator from '@Components/Utilities/Translator';

const BuyersPremiumModal = (props) => {

    const onClose = () => {
        props?.onClose?.() || props.setBuyersPremiumData?.(null);
    };

    return (
        <Modal containerClassName='buyers-premium-modal' onEscapeKeyClose={onClose}>
            <Modal.Header onClose={onClose}>
                <Modal.Title>
                    {translator.translate('sandhills.buyerspremium')}
                    </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p id='description-label' className='hidden'>View Buyer's Premium</p>
                <BuyersPremiumForm {...props} showCalculator />
            </Modal.Body>
        </Modal>
    );
};

export default BuyersPremiumModal;